import { UserData } from '@/models/user-data.model';
import { HttpClient } from '@angular/common/http';
import { Injectable, signal } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import { genericProfileImg } from '../data/generic-profile';
import { AppStateService } from '../app/app-state.service';
import { learningUsers } from '../data/learning/learning-users';

@Injectable({
  providedIn: 'root'
})
export class UsersService {
  private BASE_URL = environment.landmark_API_URL + '/users';
  userList = signal<UserData[]>([]);

  selectedUser = signal<UserData | null>(null);

  constructor(private http: HttpClient, private appStateService: AppStateService) { 
    this.populateUserList();
    console.log('users service constructor');
  }

  getUserProfileImage(UID: number): Observable<string> {
    return new Observable<string>(observer => {
      const user = this.getUserDataByUID(UID);
      const profilePicture = user?.profilePicture;

      if (profilePicture) {
        observer.next(`data:image/jpeg;base64,${profilePicture}`);
      } else {
        observer.next(genericProfileImg);
      }
      observer.complete();
    });
  }

  getUserDataByUID(UID: number): UserData | undefined {
    const userList = this.userList();
    return userList.find(user => user.UID === UID);
  }

  getUsersByOffice(fid: number | null): UserData[] {
    return this.userList().filter(user => 
      user.UserRoles?.some(userRole => 
        userRole.PermRoles?.FID === fid || fid === null
      )
    );
  }

  populateUserList() {
    if (this.appStateService.learningMode()) {
      this.userList.set(learningUsers);
    } else {
      this.http.get<UserData[]>(`${this.BASE_URL}/directory`).subscribe(users => {
        console.log('users fetched', users);
        this.userList.set(users);
      });
    }
  }

}